import { useState, useEffect } from "react";
import classNames from "classnames";
import styles from "./style.module.scss";
import Switch from "../switch";

interface NotificationPreferenceProps {
  icon: React.ReactNode;
  emailEnabled?: boolean;
  onEmailToggleChange?: (checked: boolean) => void;
}

const NotificationPreference = ({
  icon,
  emailEnabled: emailEnabledProp,
  onEmailToggleChange,
}: NotificationPreferenceProps) => {
  const [emailEnabledInternal, setEmailEnabledInternal] = useState(
    emailEnabledProp || false,
  );
  const emailEnabled =
    emailEnabledProp !== undefined ? emailEnabledProp : emailEnabledInternal;

  useEffect(() => {
    if (emailEnabledProp !== undefined) {
      setEmailEnabledInternal(emailEnabledProp);
    }
  }, [emailEnabledProp]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    if (onEmailToggleChange) {
      onEmailToggleChange(checked);
    } else {
      setEmailEnabledInternal(checked);
    }
  };

  return (
    <div className={classNames(styles.mainEnclosure, "grid")}>
      <div className={classNames(styles.firstHalf, "flex")}>
        <div className={classNames(styles.icon)}>{icon}</div>
        <div className={classNames(styles.textEnclosure, "grid")}>
          <h3 className={classNames(styles.title)}>Notification Preferences</h3>
          <p className={classNames(styles.description)}>
            Do you wish to receive email notifications for project updates?
          </p>
        </div>
      </div>
      <div
        className={classNames(styles.emailNotification, "flex justify-between")}
      >
        <h5 className={classNames(styles.emailHeading)}>Email Notification</h5>
        <Switch toggle={emailEnabled} handleChange={handleChange} />
      </div>
    </div>
  );
};

export default NotificationPreference;
